import { Component, ViewChild } from '@angular/core';
import { AlertController, Loading, LoadingController, ToastController, ViewController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { FontsProvider } from "../../../../providers/retirement-tools/fonts/fonts";
import * as jsPDF from 'jspdf';
import * as jsPDFCustomFonts from 'jspdf-customfonts';
import * as jsPDFAutotable from 'jspdf-autotable';
import moment from 'moment';
import { ConstsProvider } from '../../../../providers/retirement-tools/consts/consts';

interface Expense {
  label: string,
  type: string,
  value: number,
  otherExpense: boolean
}

interface Types {
  label: string,
  value: number
}

interface Average {
  label: string,
  average: number,
  type: string,
  index: number
}

interface Retirement {
  label: string,
  otherExpense: boolean,
  type: string,
  value: number
}

interface Expenses {
  types: Types[],
  monthlyIncome: number,
  total: number,
  average: Average[],
  retirement: Retirement[],
  totalInRetirement: number,
  months: [
    {
      monthlyIncome: number,
      visible: boolean,
      total: number,
      types: Types[],
      expense: Expense[]
    }
  ]
}

@Component({
  selector: 'expense-calculator',
  templateUrl: 'expense-calculator.html'
})
export class ExpenseCalculatorComponent {
  @ViewChild("canvas1") canvas1;
  @ViewChild("canvas2") canvas2;
  private labels: string[] = ["Necesario", "Estilo de vida", "Adicional"];
  public doughnutChartDataopts = {
    rotation: 1 * Math.PI,
    circumference: 1 * Math.PI,
    responsive: true,
    label: this.labels,
    labels: this.labels,
    legend: { display: false }
  }
  public doughnutChartData1: number[] = [0, 0, 0];
  public doughnutChartData2: number[] = [0, 0, 0];
  public doughnutChartLabels1: string[] = this.labels;
  public doughnutChartLabels2: string[] = this.labels;
  public doughnutChartType: string = 'doughnut';
  public dougnutChartcolors: Array<any> = [{
    backgroundColor: ['#463685', '#f53d3d', '#4db2eb'],
    label: this.labels
  }];
  private fillColorHead: number[] = [0, 122, 169];
  private fillColorFoot: number[] = [5, 105, 142];
  private fileName: string = 'reporte-de-gastos-actuales-y-a-la-jubilacion.pdf';
  public colors = ['royal', 'danger', 'primary', 'secondary']
  private loading: Loading;
  private userCollection: string = 'Users/';
  private expensesLabels: Expense[];
  public expenses: Expenses = {
    monthlyIncome: 10000,
    types: [],
    total: 0,
    average: [],
    retirement: [],
    totalInRetirement: 0,
    months: [{
      monthlyIncome: 10000,
      total: 2000,
      visible: false,
      types: [],
      expense: []
    }]
  };
  public urlImg: any;

  constructor(public Const: ConstsProvider, public fonts: FontsProvider, public toastCtrl: ToastController, public viewCtrl: ViewController, private loadingCtrl: LoadingController, public alertCtrl: AlertController, private afs: AngularFirestore, private afAuth: AngularFireAuth) {
    this.init();
  }

  init() {
    this.expensesLabels = this.Const.expensesLabels;
    this.expenses.months[0].expense = this.expensesLabels;
    this.expensesLabels.forEach(element => {
      this.expenses.retirement.push({ "label": element.label, "otherExpense": false, "type": element.type, "value": element.value });
    });
  }

  ngOnInit() {
    this.startCalculating();
  }

  changeValue() {
    this.calculate();
    this.paintGraph1();
  }

  startCalculating() {
    this.calculate();
    this.loadData();
  }

  loadData() {
    this.presentLoading();
    this.afAuth.authState.subscribe(user => {
      const uuid = user.uid
      this.afs.doc("Expenses/" + uuid).ref.get().then(doc => {
        if (doc.exists) {
          this.expenses = doc.data() as any;
          this.calculate();
          this.paintGraph1();
        }
        this.loading.dismiss();
      });
    });
  }

  saveData() {
    this.presentLoading();
    const uuid = this.afAuth.auth.currentUser.uid;
    this.afs.doc("Expenses/" + uuid).set(this.expenses).then(() => {
      this.loading.dismiss();
      this.presentToast("Guardado correctamente!");
      this.viewCtrl.dismiss();
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast("Ha ocurrido un error!");
    });
  }

  calculate() {
    let average: any[] = [];
    this.expenses.months.forEach((element, index) => {
      element.expense.forEach(element => {
        average.push(element);
      });
      const types = this.removeDuplicateItems(element.expense.map(element => element.type));
      let arrayTypes: Types[] = [];
      types.forEach(type => {
        let totalPerType: number = 0;
        element.expense.forEach(element => {
          if (element.type == type) {
            totalPerType += Number(element.value);
          }
        });
        arrayTypes.push({ "label": type, "value": totalPerType });
      });
      this.expenses.months[index].types = arrayTypes;
      let total: number = 0;
      this.expenses.months[index].types.forEach(type => {
        total += Number(type.value);
      });
      this.expenses.months[index].total = total;
    });
    this.average(average);
  }

  average(expenseArray: Expense[]) {
    //const labels = this.removeDuplicateItems(expenseArray.map(element => element.label));
    const types = this.removeDuplicateItems(expenseArray.map(element => element.type));
    const expenses: Average[] = [];
    // labels.forEach((label) => {
    //   types.forEach(type => {
    //     let sum: number = 0;
    //     expenseArray.forEach(element => {
    //       if (element.label == label && element.type == type) {
    //         sum += Number(element.value);
    //       }
    //     });
    //     if (!(sum == 0)) {
    //       const average: number = sum / this.expenses.months.length;
    //     }
    //   });
    // });
    this.expenses.months[0].expense.forEach((element1, index) => {
      let average: number = 0;
      types.forEach(type => {
        let sum: number = 0;
        expenseArray.forEach(element2 => {
          if (element2.label == element1.label && element2.type == type) {
            sum += Number(element2.value);
          }
        });
        if (!(sum == 0)) {
          average = sum / this.expenses.months.length;
        }
      });
      expenses.push({ "label": element1.label, "type": element1.type, "average": average, "index": index });
    });


    this.expenses.average = expenses;
    let total: number = 0;
    this.expenses.average.forEach(element => {
      total += Number(element.average);
    });
    let monthlyIncome: number = 0;
    this.expenses.months.forEach(element => {
      monthlyIncome += Number(element.monthlyIncome);
    });
    let finalExpenseArray: any[] = [];
    types.forEach(type => {
      let totalExpenses: number = 0;
      this.expenses.average.forEach(element => {
        if (type == element.type) {
          totalExpenses += element.average;
        }
      });
      finalExpenseArray.push({ label: type, value: totalExpenses });
    });
    this.expenses.total = total;
    this.expenses.types = finalExpenseArray;
    this.expenses.monthlyIncome = monthlyIncome / this.expenses.months.length;
    let indexes: number[] = [];
    this.expenses.retirement.forEach((element, index) => {
      const exist: number = this.expenses.average.map(element => element.label).indexOf(element.label);
      if (exist > -1) {
        indexes.push(undefined);
      } else {
        indexes.push(index);
      }
    });
    indexes.forEach((element, index) => {
      if (typeof (element) == 'number') {
        this.expenses.retirement[index].value = 0;
      }
    });
    this.paintGraph2();
  }

  paintGraph1(): void {
    let totalInRetirement: number = 0;
    this.expenses.retirement.forEach(element => {
      totalInRetirement += Number(element.value);
    });
    this.expenses.totalInRetirement = totalInRetirement;
    this.doughnutChartLabels2 = [];
    this.doughnutChartData2 = [];
    this.expenses.types = this.orderArrayTypes(this.expenses.types);
    this.expenses.types.forEach(element => {
      this.doughnutChartLabels2.push(element.label);
      this.doughnutChartData2.push(this.getTotalOfTypes(element.label));
    });
  }

  private orderArrayTypes(types: Types[]): Array<Types> {
    let finalTypes: Types[] = [];
    this.labels.forEach(element => {
      const index = types.map(element => element.label).indexOf(element);
      if (index > -1) {
        finalTypes.push(types[index])
      }
    });
    return finalTypes;
  }

  paintGraph2(): void {
    this.doughnutChartLabels1 = [];
    this.doughnutChartData1 = [];
    this.expenses.types = this.orderArrayTypes(this.expenses.types);
    this.expenses.types.forEach(element => {
      this.doughnutChartLabels1.push(element.label);
      this.doughnutChartData1.push(element.value);
    });
  }

  getTotalOfTypes(message: string): number {
    var number: number = 0;
    this.expenses.retirement.forEach(element => {
      if (element.type == message) {
        number += Number(element.value);
      }
    });
    return number;
  }

  removeDuplicateItems(arrayTypes: string[]) {
    let uniqueArray: string[] = [];
    for (let i = 0; i < arrayTypes.length; i++) {
      if (uniqueArray.indexOf(arrayTypes[i]) == -1) {
        uniqueArray.push(arrayTypes[i])
      }
    }
    return uniqueArray
  }

  deleteAll() {
    this.presentLoading();
    const uid = this.afAuth.auth.currentUser.uid;
    this.afs.doc("Expenses/" + uid).delete().then(() => {
      this.loading.dismiss();
      this.viewCtrl.dismiss();
      this.presentToast("Gastos eliminados correctamente!");
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast("Ha ocurrido un error!");
    });
  }

  getAverage(index: number): number {
    let average: number = 0;
    this.expenses.average.forEach(element => {
      if (element.index == index) {
        average = element.average;
      }
    });
    return average;
  }

  public addMonth(): void {
    let elements = [];
    this.expenses.months[this.expenses.months.length - 1].expense.forEach(element => {
      const label = element.label;
      const otherExpense = element.otherExpense;
      const type = element.type;
      const value = element.value;
      elements.push({ "label": label, "otherExpense": otherExpense, "type": type, "value": value });
    });
    this.expenses.months.push({ "monthlyIncome": this.expenses.months[this.expenses.months.length - 1].monthlyIncome, "total": 0, "visible": false, "types": [], "expense": elements });
    this.calculate();
  }

  closeMonth(index: number) {
    if (this.expenses.months[index].visible) {
      this.expenses.months[index].visible = false;
    } else {
      this.expenses.months[index].visible = true;
    }
  }

  public deleteItem(month: number, index: number): void {
    this.expenses.months[month].expense.splice(index, 1);
    this.calculate();
  }

  changeType(value: any, index: number): void {
    this.expenses.months.forEach(element => {
      element.expense[index].type = value;
      this.expenses.retirement[index].type = value;
    });
    this.changeValue();
  }

  updateLabel(index: number, label: string) {
    if (!(this.expenses.months[0].expense.map(element => { return element.label }).indexOf(label) > -1) && label != '') {
      this.expenses.months.forEach(element => {
        element.expense[index].label = label;
      });
      this.changeValue();
    }
  }

  deleteMonth(index: number) {
    this.expenses.months.splice(index, 1);
    this.calculate();
  }

  setMonthlyIncome(index: number, monthlyIncome: number) {
    this.expenses.months[index].monthlyIncome = Number(monthlyIncome);
    this.calculate();
  }

  showPrompt(index: number) {
    const prompt = this.alertCtrl.create({
      title: 'Mes ' + (index + 1),
      message: "¿Cuáles fueron tus ingresos?",
      inputs: [
        {
          name: 'monthlyIncome',
          placeholder: 'Ingreso mensual',
          type: 'number'
        },
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Guardar',
          handler: data => {
            this.setMonthlyIncome(index, data.monthlyIncome);
          }
        }
      ]
    });
    prompt.present();
  }

  showPrompt2(index: number) {
    const prompt = this.alertCtrl.create({
      title: 'Eliminar gastos',
      message: "¿Estas seguro de eliminar todos tus gastos?",
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteAll();
          }
        }
      ]
    });
    prompt.present();
  }

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 4000
    });
    toast.present();
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({});
    this.loading.present();
  }

  showConfirm(month: number, index: number) {
    const confirm = this.alertCtrl.create({
      title: 'Eliminar gasto?',
      message: 'Estas seguro de eliminar éste gasto?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Borrar',
          handler: () => {
            this.deleteItem(month, index);
          }
        }
      ]
    });
    confirm.present();
  }

  showConfirmTwo(index: number) {
    const confirm = this.alertCtrl.create({
      title: 'Eliminar mes?',
      message: 'Estas seguro de eliminar éste mes?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Borrar',
          handler: () => {
            this.deleteMonth(index);
          }
        }
      ]
    });
    confirm.present();
  }

  showPrompt4(index: number) {
    const prompt = this.alertCtrl.create({
      title: 'Modificar gasto',
      inputs: [
        {
          name: 'gasto',
          placeholder: 'nombre de gasto',
          type: 'text'
        },
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Guardar',
          handler: data => {
            this.updateLabel(index, data.gasto);
          }
        }
      ]
    });
    prompt.present();
  }

  async imageToDataURL(url: string) {
    return await new Promise(resolve => {
      let xhr = new XMLHttpRequest();
      xhr.onload = () => {
        var reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  public dateNow(): string {
    return moment().format("DD/MM/YYYY, h:mm a");
  }

  public myDate(date?: any): string {
    let ret;
    if (date) {
      ret = moment(date.toDate()).format("DD/MM/YYYY");
    } else {
      ret = moment().format("DD/MM/YYYY");
    }
    return ret;
  }

  pdf() {
    const doc = new jsPDF("portrait", "px", "a4");
    const JsPDFCustomFonts = jsPDFCustomFonts;
    const JsPDFAutotable = jsPDFAutotable;
    doc.addFileToVFS('Montserrat-Regular.ttf', this.fonts.MonserratRegular);
    doc.addFileToVFS('Montserrat-Bold.ttf', this.fonts.MonserratBold);
    doc.addFont('Montserrat-Regular.ttf', 'Montserrat', 'normal');
    doc.addFont('Montserrat-Bold.ttf', 'Montserrat', 'bold');
    doc.setFont('Montserrat');
    const promise1 = this.imageToDataURL('assets/imgs/pdf/header2.jpg');
    const promise2 = this.imageToDataURL('assets/imgs/pdf/footer.jpg');
    const canvasEl1: HTMLCanvasElement = this.canvas1.nativeElement;
    const dataURL1 = canvasEl1.toDataURL('image/png', 1.0);
    const canvasEl2: HTMLCanvasElement = this.canvas2.nativeElement;
    const dataURL2 = canvasEl2.toDataURL('image/png', 1.0);
    const uid = this.afAuth.auth.currentUser.uid;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    });
    Promise.all([promise1, promise2]).then(values => {
      this.afs.doc(this.userCollection + uid).ref.get().then(user => {
        doc.addImage(values[0], 'JPEG', -1, -1, 450, 110);
        doc.setTextColor(221, 12, 12);
        doc.setFontType('bold');
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.setFontSize(9); doc.setTextColor(0, 0, 0);
        doc.setTextColor(256, 256, 256);
        doc.setFontSize(16);
        doc.text(45, 102, 'Reporte de gastos actuales y a la jubilación');
        doc.setTextColor(0, 0, 0);
        doc.setFontType('bold');

        ///Gastos Hoy
        doc.setFontSize(12);
        doc.text(20, 195, 'Tus gastos promedio actuales');
        doc.addImage(dataURL1, 'JPEG', 20, 215, 180, 90);

        doc.setDrawColor(0);
        doc.setFillColor(70, 54, 133);
        doc.roundedRect(20, 320, 10, 10, 3, 3, 'FD');
        doc.text(35, 328, 'Necesario:');
        doc.setFontType('normal');
        doc.setFontSize(10);
        doc.text(105, 328, this.percent(this.doughnutChartData1[0], this.expenses.total));
        doc.setFontSize(12);
        doc.text(128, 328, "  " + formatter.format(this.doughnutChartData1[0]));

        doc.setFontType('bold');
        doc.setFillColor(245, 61, 61);
        doc.roundedRect(20, 335, 10, 10, 3, 3, 'FD');
        doc.text(35, 343, 'Estilo de vida:');
        doc.setFontType('normal');
        doc.setFontSize(10);
        doc.text(105, 343, this.percent(this.doughnutChartData1[1], this.expenses.total));
        doc.setFontSize(12);
        doc.text(128, 343, "  " + formatter.format(this.doughnutChartData1[1]));

        doc.setFontType('bold');
        doc.setFillColor(77, 178, 235);
        doc.roundedRect(20, 350, 10, 10, 3, 3, 'FD');
        doc.text(35, 358, 'Adicional:');
        doc.setFontType('normal');
        doc.setFontSize(10);
        doc.text(105, 358, this.percent(this.doughnutChartData1[2], this.expenses.total));
        doc.setFontSize(12);
        doc.text(128, 358, "  " + formatter.format(this.doughnutChartData1[2]));

        doc.line(20, 365, 205, 365);
        doc.setFontType('bold');
        doc.text(20, 380, 'Total:');
        doc.setFontType('normal');
        doc.text(128, 380, "  " + formatter.format(this.expenses.total));

        ///Gastos Jubilación
        doc.setFontType('bold');
        doc.text(246, 195, 'Tus gastos estimados a la jubilación');
        doc.addImage(dataURL2, 'JPEG', 246, 215, 180, 90);

        doc.setDrawColor(0);
        doc.setFillColor(70, 54, 133);
        doc.roundedRect(242, 320, 10, 10, 3, 3, 'FD');
        doc.text(257, 328, 'Necesario:');
        doc.setFontType('normal');
        doc.setFontSize(10);
        doc.text(327, 328, this.percent(this.doughnutChartData2[0], this.expenses.totalInRetirement));
        doc.setFontSize(12);
        doc.text(350, 328, "  " + formatter.format(this.doughnutChartData2[0]));

        doc.setFontType('bold');
        doc.setFillColor(245, 61, 61);
        doc.roundedRect(242, 335, 10, 10, 3, 3, 'FD');
        doc.text(257, 343, 'Estilo de vida:');
        doc.setFontType('normal');
        doc.setFontSize(10);
        doc.text(327, 343, this.percent(this.doughnutChartData2[1], this.expenses.totalInRetirement));
        doc.setFontSize(12);
        doc.text(350, 343, "  " + formatter.format(this.doughnutChartData2[1]));

        doc.setFontType('bold');
        doc.setFillColor(77, 178, 235);
        doc.roundedRect(242, 350, 10, 10, 3, 3, 'FD');
        doc.text(257, 358, 'Adicional:');
        doc.setFontType('normal');
        doc.setFontSize(10);
        doc.text(327, 358, this.percent(this.doughnutChartData2[2], this.expenses.totalInRetirement));
        doc.setFontSize(12);
        doc.text(350, 358, "  " + formatter.format(this.doughnutChartData2[2]));

        doc.line(242, 365, 427, 365);
        doc.setFontType('bold');
        doc.text(242, 380, 'Total:');
        doc.setFontType('normal');
        doc.text(350, 380, "  " + formatter.format(this.expenses.totalInRetirement));
        //Fin de gatos
        let body2: any[] = [];
        this.expenses.average.forEach(e => {
          body2.push([String(e.label), String(e.type), formatter.format(Number(e.average)), formatter.format(Number(this.expenses.retirement[e.index].value))]);
        });
        if (!(body2.length > 0)) {
          body2 = [['-', '-', '-', '-']]
        }
        let body1: any[] = [];
        this.expenses.types.forEach(e => {
          body1.push([String(e.label), formatter.format(Number(e.value)), formatter.format(Number(this.getTotalOfTypes(e.label)))]);
        });
        if (!(body1.length > 0)) {
          body1 = [['-', '-', '-', '-']]
        }
        doc.autoTable({
          columnStyles: { 0: { cellWidth: 160, minCellWidth: 160, valign: 'middle' }, 1: { cellWidth: 40, valign: 'middle' }, 2: { cellWidth: 30, valign: 'middle' }, 3: { cellWidth: 30, valign: 'middle' } },
          headStyles: { fillColor: this.fillColorHead, valign: 'middle' },
          footStyles: { fillColor: this.fillColorFoot },
          head: [['Descripción', 'Tipo', 'Gastos\npromedio\nactuales', 'Gastos\nestimados\na la jubilación']],
          body: body2,
          startY: 415,
          margin: { top: 80 },
        });
        body2 = [];
        var pageCount = doc.internal.getNumberOfPages();

        for (let i = 0; i < pageCount; i++) {
          const index = i + 1;
          //footer
          doc.setPage(index);
          doc.addImage(values[1], 'JPEG', -1, 605, 450, 22);
          doc.setFontSize(9);
          doc.setTextColor(0, 0, 0);
          doc.text(185, 625, 'Página ' + index + ' de ' + pageCount);
          //header
          if (i == 0) {
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(12);
            doc.setFontType('bold');
            doc.text(20, 130, 'Fecha:');
            doc.setFontType('normal');
            doc.text(60, 130, this.dateNow());
            doc.setFontType('bold');
            doc.text(20, 145, 'Nombre:');
            doc.setFontType('normal');
            doc.text(70, 145, String(user.get("name") ? user.get("name") : '') + ' ' + String(user.get("lastName") ? user.get("lastName") : ''));
            doc.setFontType('bold');
            doc.text(20, 160, 'Meses analizados:');
            doc.setFontType('normal');
            doc.text(115, 160, String(this.expenses.months.length));
          } else {
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(12);
            doc.setFontType('bold');
            doc.text(20, 30, 'Fecha:');
            doc.setFontType('normal');
            doc.text(60, 30, this.dateNow());
            doc.setFontType('bold');
            doc.text(20, 45, 'Nombre:');
            doc.setFontType('normal');
            doc.text(70, 45, String(user.get("name") ? user.get("name") : '') + ' ' + String(user.get("lastName") ? user.get("lastName") : ''));
            doc.setFontType('bold');
            doc.text(20, 60, 'Meses analizados:');
            doc.setFontType('normal');
            doc.text(115, 60, String(this.expenses.months.length));
          }

        }
        doc.save(this.fileName);
      });
    });
  }

  ngAfterViewInit() {
    const canvasEl1: HTMLCanvasElement = this.canvas1.nativeElement;
    var dataURL = canvasEl1.toDataURL();
    this.urlImg = dataURL;
  }

  percent(portion: number, total: number): string {
    const prom: number = (portion / total) * 100;
    return prom > -1 ? prom.toFixed() + '%' : "0%";
  }

}



// WEBPACK FOOTER //
// ./src/components/retirement-tools/expense-calculator/expense-calculator/expense-calculator.ts